import React, { useState } from 'react';
import { useAccount } from 'wagmi';
import { Grid } from '@mui/material';
import Strings from 'utils/Strings';
import { NFT } from 'models/NFT';
import CMPButton from 'components/global/button';
import DialogModal from 'components/global/dialog-modal';
import { SaleType } from '../../../../store/market/types';

interface IActionButtonProps {
  nft: NFT;
  onRefresh?: () => void;
}

const ActionButton: React.FunctionComponent<IActionButtonProps> = ({ nft, onRefresh }) => {
  const { address } = useAccount();
  const [buyOpen, setBuyOpen] = useState(false);
  const { sale, numeralPrice } = nft;

  const onClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    if (nft.actionType(address) === 'BID' || nft.actionType(address) === 'BUY') {
      setBuyOpen(true);
    }
  };

  const onClose = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setBuyOpen(false);
  };

  const onSuccess = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setBuyOpen(false);
    if (onRefresh) {
      onRefresh();
    }
  };
  if (sale && nft.actionType(address) === 'BID') {
    const { saleId, bidToken, type, bidder } = sale;
    return (
      <>
        <Grid container spacing={1} className="mt-3 px-2">
          <Grid item xs={6}>
            <CMPButton fullWidth onClick={onClick}>
              {nft.actionType(address)}
            </CMPButton>
          </Grid>
          <Grid item xs={6}>
            <CMPButton fullWidth variant="outlined" className="text-uppercase">
              {Strings.details}
            </CMPButton>
          </Grid>
        </Grid>
        <DialogModal
          open={buyOpen}
          onClose={onClose}
          title={type === SaleType.FIXED ? 'Fixed Price Method' : 'Auction Method'}
          contentProps={{ className: 'small-scrollbar' }}
          maxWidth={type === SaleType.FIXED ? 'xs' : 'sm'}
        ></DialogModal>
      </>
    );
  }

  return (
    <CMPButton fullWidth variant="outlined" className="mt-4 mx-2 text-uppercase">
      {Strings.details}
    </CMPButton>
  );
};
export default ActionButton;
